import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material"

interface RevokeConfirmDialogProps {
  open: boolean
  appName?: string | null
  onClose: () => void
  onConfirm: () => void
}

export default function RevokeConfirmDialog({ open, appName, onClose, onConfirm }: RevokeConfirmDialogProps) {
  return <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
    <DialogTitle>Delete Connection</DialogTitle>
    <DialogContent>
      <DialogContentText>
        Are you sure you want to disconnect <strong>{appName || "this application"}</strong>? This will revoke all access permissions and end the active session. You can reconnect the application at any time.
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} color="secondary">
        Cancel
      </Button>
      <Button onClick={onConfirm} color="error" variant="contained">
        Disconnect
      </Button>
    </DialogActions>
  </Dialog>
}
